import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class NewExpoDialog
 * A component for creating a new Expo
 */
export default class NewExpoDialog extends Component {
  /** @constructor
    * Creates a new instance of NewExpoDialog
    */
  constructor(props) {
    super(props);
    this.state = {
      name: "New Expo",
      host: "newexpo.com"
    }
    this.handleChange = this.handleChange.bind(this);
    this.createNewExpo = this.createNewExpo.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @method createNewExpo
    * Creates a new expo and adds it to Firebase
    */
  createNewExpo() {
    // determine the expo id
    var expoID = this.state.name.toLowerCase().replace(/\s+/g, '-');
    // check that id is not taken
    firebase.database().ref(`expos/${expoID}`).once('value', snapshot => {
      // Substitute a auto-generated id if it does
      if(snapshot.exists()) expoID = firebase.database().ref().push();
      // Build the expo with default settings
      var expo = {
        metadata: {
          name: this.state.name,
          host: this.state.host,
          status: "Under Construction"
        },
        shows: {
          sample: {
            metadata: {
              name: `Sample ${this.state.name}`,
              isSample: true,
              backgroundNoise: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fnoise.wav?alt=media&token=b21c5b22-9dea-41ae-b024-090ef15b6cb7",
              status: 'Under Construction',
              logo: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fvexpo-logo.png?alt=media&token=a1972550-76f7-461f-9b42-a8d3d951e78a",
              icon: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Ffavicon.ico?alt=media&token=f0b6d40a-f4bf-491f-aca6-de577143b637"
            },
            policies: {
              privacy: "<h1>Privacy Policy</h1>\n<p><strong>Updated 6/12/2018</strong></p>\n<p><br></p>\n<p>We understand your privacy is important to you, and we do our best to respect it as we hope others respect our own privacy. &nbsp;The following describes what information we collect, why, and how we use it.</p>\n<h3>Login Information</h3>\n<p>The show provides services like a personalized showbag where you can save the show giveaways, brochures, coupons, etc. &nbsp;To keep track of this information and allow you quick access across all your devices, we need to differentiate between people. &nbsp;For this reason, to attend the show please create an account using your email, Twitter, Facebook, or Instagram.</p>\n<p><br></p>\n<p>The Show does not share this login information with any business, show exhibitor, or third party. Your email will only be used to reset your password (should you forget it), and to send you notices of future shows. &nbsp;We dislike spam as much as you do, so we keep those notifications to a minimum.</p>\n<h3>Show Survey</h3>\n<p>We ask some attendees to fill out a show survey for the purpose of improving our show for future attendees. &nbsp;As a reward for participating, we offer a drawing for prizes among the participants. &nbsp;Clearly, we need to contact you if you win &nbsp;- so we ask in the survey for your email. If you choose not to include your contact info, your survey will be completely anonymous (but you will not be entered into the drawing).</p>\n<h3>Show Exhibitors</h3>\n<p>The Show provides links to exhibitor websites and resources outside of our show. &nbsp;These are not covered by our privacy policy, but by those of the individual exhibitor. &nbsp;Please consult their privacy policies for more information.</p>",
              tos: "<h1>Terms of Service</h1>\n<p><strong>Updated 6/12/2018</strong></p>\n<p><br></p>\n<p>The Show is a virtual outdoor sports exhibition you can attend on any computer or mobile device. This page describes the terms and conditions of utilizing this service. &nbsp;<strong>Any use of this service will constitute acceptance of these terms and conditions.</strong></p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>\n<p>Using the Show requires creating an account. &nbsp;What information is collected and how it is used is covered in our Privacy Policy.</p>\n<p><br></p>\n<p>The Show and its components are offered for informational purposes only; this Show shall not be responsible or liable for the accuracy, usefulness or availability of any information transmitted or made available via the Show, and shall not be responsible or liable for any error or omissions in that information.</p>\n<p><br></p>\n<p>The Show and its original content, features, and functionality are owned by Vexpo Shows and/or individual exhibitors in the show and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>\n<p><br></p>\n<p>The Show represents significant work and intellectual investment by a dedicated group. We ask that you respect that. &nbsp;By using the show, you agree not to reverse engineer, decompile, disassemble or otherwise attempt to derive the source code, techniques, processes, algorithms, know-how or other information from the HTML, JavaScript, and CSS source code, or permit or induce others to do so.</p>"
            },
            showbag: {
              background: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fcarryout-bag.png?alt=media&token=8c091923-7ade-425f-a568-3ed84f92689b",
              contents: {}
            },
            backgrounds: {
              exhibitorListing: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fbooth-list.jpg?alt=media&token=23a31acf-cdb2-40af-9e42-4477c2f5b136",
              showLocations: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Flocation-kiosk.gif?alt=media&token=e3fdab2e-90df-4c9e-a163-9643dc756d58"
            },
            entry: {
              stage: {width: 1024, height: 768}
            },
            lobby: {
              stage: {width: 1024, height: 768}
            }
          }
        }
      }
      // Upload the new expo to the firebase database
      firebase.database().ref(`expos/${expoID}`).set(expo, () => {
        this.props.onExit();
      });
    });
  }
  /** @function render
    * Renders the component.
    */
  render() {
    if(!this.props.show) return null;
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}><FontAwesome name="times"/></button>
            </div>
            <div>
              <div className="input-group">
                <label htmlFor="name">Name</label>
                <input name="name" type="text"
                  value={this.state.name}
                  onChange={this.handleChange}/>
              </div>
              <div className="input-group">
                <label htmlFor="host">Host</label>
                <input name="host" type="text"
                  value={this.state.host}
                  onChange={this.handleChange}/>
              </div>
              <button
                className="btn btn-success"
                onClick={this.createNewExpo}>
                  Create New Expo
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/expo-list/new-expo-dialog.js